import { render, staticRenderFns } from "./SubscribeButton.vue?vue&type=template&id=55e7f13b&scoped=true"
import script from "./SubscribeButton.vue?vue&type=script&lang=js"
export * from "./SubscribeButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55e7f13b",
  null
  
)

export default component.exports